import { useState } from "react";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import withLoader from "../../components/layouts/WithLoader";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import ProductService from "../../services/ProductService";
import DataTableProductsSearch from "./DataTableProductsSearch";

const ProductSearchWarehouses = ({ startLoading, stopLoading }) => {
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [barcode, setBarcode] = useState("");
  const [listProduits, setListProduits] = useState([]);
  const [searched, setSearched] = useState(false);
  const [lastQuery, setLastQuery] = useState("");

  const onChangeBarcodeHandler = (event) => {
    setBarcode(event.target.value);
  };

  const getProductInfos = () => {
    if (barcode.trim() === "") return;
    startLoading();
    setListProduits([]);
    setSearched(false);
    setLastQuery(barcode.trim());

    ProductService.searchProducts(getCurrentUserId(), barcode.trim())
      .then((response) => {
        if (response.data.success) {
          setListProduits(response?.data?.success);
        }
        setSearched(true);
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };

  const onClear = () => {
    setBarcode("");
    setListProduits([]);
    setSearched(false);
    setLastQuery("");
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenErrorAlert(false);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <h4 className="mb-1">
            <i className="fas fa-search mr-2"></i>Chercher un produit
          </h4>
          <small className="text-muted">
            Recherchez un produit par son libellé, son code article ou son code
            à barre
          </small>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div
            className="card card-outline card-dark mt-3"
            style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" }}
          >
            <div className="card-body py-3">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text bg-white border-right-0">
                    <i className="fas fa-search text-muted"></i>
                  </span>
                </div>
                <input
                  id="productSearch"
                  type="text"
                  className="form-control border-left-0"
                  placeholder="Libellé, code article ou code à barre"
                  value={barcode}
                  onChange={onChangeBarcodeHandler}
                  onKeyDown={(e) => e.key === "Enter" && getProductInfos()}
                  autoFocus
                />
                {barcode !== "" && (
                  <div className="input-group-append">
                    <button
                      type="button"
                      title="Effacer"
                      className="btn btn-outline-secondary"
                      onClick={onClear}
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  </div>
                )}
                <div className="input-group-append">
                  <button
                    className="btn btn-dark px-4"
                    onClick={getProductInfos}
                    disabled={barcode.trim() === ""}
                  >
                    Rechercher
                  </button>
                </div>
              </div>
              <small className="text-muted d-block mt-2">
                Appuyez sur Entrée pour lancer la recherche.
              </small>
            </div>
          </div>

          {searched && listProduits.length > 0 && (
            <p className="text-muted mb-2">
              <strong>{listProduits.length}</strong> résultat
              {listProduits.length > 1 ? "s" : ""} pour «&nbsp;{lastQuery}&nbsp;»
            </p>
          )}

          {listProduits.length > 0 && (
            <DataTableProductsSearch listProduits={listProduits} />
          )}

          {searched && listProduits.length === 0 && (
            <div className="text-center text-muted py-5">
              <i className="fas fa-box-open fa-2x mb-2 d-block"></i>
              Aucun produit trouvé pour «&nbsp;{lastQuery}&nbsp;»
              <small className="d-block mt-1">
                Essayez avec un autre libellé ou un autre code.
              </small>
            </div>
          )}
        </div>
      </section>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(ProductSearchWarehouses);
